import React, { Component } from "react";
import { connect } from "react-redux";
import ListItem from "@material-ui/core/ListItem";
import "./ListItem.css";
import { Link } from "react-router-dom";
import Quantity from "../Quantity";
import { setProduct } from "../../../store/actions/b2b";
import { withRouter } from "react-router-dom";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class Item extends Component {
  state = { quantity: 0 };

  render() {
    const { language, settings } = this.props;
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const currency =
      language === "english"
        ? settings?.currency_english
        : settings?.currency_local;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <>
        <ListItem
          className="ml-0"
          style={{
            flexDirection: language === "english" ? "row" : "row-reverse",
            marginBottom: 10,
            paddingBottom: 24,
            paddingTop: 14,
          }}
        >
          <Link
            to={{
              pathname: `/${this.props.match.params.slug}/distributor/product/${this.props.product.category_slug}/${this.props.product.slug}`,
            }}
            onClick={() => {
              this.props.setProduct(this.props.productInfo);
            }}
            style={{ display: "flex", width: "100%", textDecoration: "none" }}
          >
            <img
              className="image_menu"
              src={
                this.props.product &&
                (this.props.product.photo_thumb || this.props.product.photo)
              }
              alt="Img"
              style={{
                width: 90,
                height: 90,
                borderRadius: 5,
                marginRight: language === "english" ? 15 : 0,
              }}
            />
            <div
              className={language === "english" ? "text-left" : "text-right"}
              style={{
                marginRight: 20,
                maxHeight: 93,
                minHeight: 62,
                width: "100%",
                position: "relative",
                top: -11,
              }}
            >
              <h6
                className={
                  language === "arabic"
                    ? "text-right cut-text-two-lines-list-b2b"
                    : "text-left cut-text-two-lines-list-b2b"
                }
                style={{
                  fontFamily: language === "english" ? "Quicksand" : "Cairo",
                  marginBottom: 2,
                  direction: language === "english" ? "ltr" : "rtl",
                  fontWeight: "bold",
                }}
              >
                {language === "english"
                  ? this.props.product.name
                  : this.props.product.ar_name}
              </h6>
              <p
                className={"text-muted m-0 cut-text-two-lines-list-b2b ".concat(
                  language === "english" ? "text-left" : "text-right"
                )}
                style={{ direction: language === "english" ? "ltr" : "rtl" }}
              >
                {language === "english"
                  ? this.props.product.short_description
                  : this.props.product.ar_short_description}
              </p>

              {this.props.showPrices && (
                <p
                  className={`${
                    language === "english"
                      ? "priceEnglish priceSmallScreen"
                      : "priceArabic priceArabicSmallScreen rtl"
                  } ${currencyIcon}`}
                  style={{
                    color: themeColor,
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    height: 35,
                    top: 62,
                    right: language === "english" ? 0 : "",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {this.props.product.price.toFixed(
                      settings.currency_decimals
                    )}{" "}
                    {currency}
                  </span>
                </p>
              )}
            </div>
          </Link>
          <div
            style={{
              position: "absolute",
              bottom: 10,
              right: language === "arabic" ? 115 : undefined,
              left: language === "english" ? 115 : undefined,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Quantity
              id={this.props.productInfo.product.id}
              product={this.props.productInfo.product}
              minimumOrderQuantity={
                this.props.productInfo.minimum_order_quantity
              }
              maximumOrderQuantity={
                this.props.productInfo.maximum_order_quantity
              }
              increments={this.props.productInfo.increments}
            />
          </div>
        </ListItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    themeColor: state.store.store.settings.dark,
    branch: state.branch,
    settings: state.store.store.settings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (prd) => dispatch(setProduct(prd)),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Item));
